import React from "react";
import { BorderContainer } from "../ui/BorderContainer.component";

export const Plan = ({ active, button, name, info, description, status }) => {
  return (
    <BorderContainer active={active}>
      <div className="flex flex-col md:flex-row justify-between items-start">
        <h2 className="font-semibold text-[28px]">{name}</h2>
        {active && (
          <div className="mt-5 md:mt-0">
            <p className="underline text-xl font-semibold inline">Status:</p>
            <span className="text-[#338CC7] no-underline ml-2 font-semibold">
              {status}
            </span>
          </div>
        )}
      </div>
      <p className="mt-5 md:mt-8">{description}</p>
      <div
        className={`flex flex-col md:flex-row gap-x-14 gap-y-6 md:gap-y-0 mt-12 ${!active && "md:items-end"
          }`}
      >
        <div className="md:w-[50%]">
          <ul className="list-disc pl-5">
            {info.map((li, index) => (
              <li key={index}>{li}</li>
            ))}
          </ul>
          <p
            className="font-semibold ml-5 underline mt-8 block text-[#338CC7]"
          >
            See more details
          </p>
        </div>
        <div className="md:w-[50%]">
          {}
        </div>
      </div>
    </BorderContainer>
  );
};
